module.exports = __webpack_public_path__ + "static/media/ellipse.f77de65a.svg";